import React, { useState, useEffect } from 'react';
import {RouteComponentProps} from 'react-router-dom'
import { Link } from 'react-router-dom';
import queryString from 'query-string';

// redux
import { closeMenu } from 'store'
import { useDispatch } from 'react-redux';

// slider
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// component
import Header from 'component/Header';
import SubHeader from 'component/SubHeader';
import Menu from 'component/Menu';
import Footer from 'component/Footer';
import FloorMap3 from 'component/FloorMap3';
import FloorMap4 from 'component/FloorMap4';
import Modal from 'component/Modal';

import './PageFloor.scss';

// json
import allData from 'json/allData';
// import { current } from '@reduxjs/toolkit';

type Props = {
  testPath: string,
} & RouteComponentProps<{floor: string, area: string}>;

const PageFloor: React.FC<Props> = (props) => {

  // dispatch
  const dispatch = useDispatch();

  // クエリ取得
  const qs = queryString.parse(props.location.search);

  // ステート初期値設定
  const [activeFloor, setActiveFloor] = useState(3);
  const [activeModal, setActiveModal] = useState(-1);
  const [activeSlide, setActiveSlide] = useState(0);

  // エリア順序データ
  const areaOrder :{id:number,title:string}[][] = [
    [
      { id:9, title:'個室' },
      { id:7, title:'SAIBI' },
      { id:8, title:'SEQUENCE' },
      { id:6, title:'SENTIR' },
      { id:5, title:'Wilkhahn' },
      { id:4, title:'STELLAR WORKS' },
      { id:3, title:'MAGIS' },
      { id:2, title:'pedrali' },
      { id:1, title:'MATTIAZZI' },
      { id:0, title:'normann copenhagen' },
    ],[
      { id:12, title:'防災' },
      { id:8, title:'会議 ミーティング コラボレーション' },
      { id:5, title:'官公庁' },
      { id:7, title:'DAYS OFFICE' },
      { id:2, title:'会議用イス' },
      { id:6, title:'オフィスチェアー' },
      { id:9, title:'ワークステーション' },
      { id:10, title:'デスク' },
      { id:0, title:'any' },
      { id:1, title:'Plocka/Mycket' },
      { id:11, title:'Working From Home' },
      { id:4, title:'医療' },
      { id:3, title:'教育' },
    ],[
      { id:16, title:'オペレーションワーク' },
      { id:14, title:'チームビルディング' },
      { id:13, title:'チームシンキング' },
      { id:15, title:'高集中ワーク' },
      { id:18, title:'特殊・専門ワーク' },
      { id:17, title:'社外関係構築' },
      { id:19, title:'高機密性ワーク' },
    ],
  ]

  // スライダー設定
  let elSlider: any;
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: (i:number) => {
      setActiveSlide(i);
    }
  };

  // 変数
  let currentFloor = 0;
  let currentArea = 0;
  let prevArea = 0;
  let nextArea = 0;

  // クエリパラメーターチェック
  // フロアのチェック
  if( props.match.params.floor === '3' || props.match.params.floor === '4' ){

    // フロア番号の取得
    currentFloor = parseInt(props.match.params.floor) - 3;

    // エリアのチェック
    if(
      parseInt(props.match.params.area) &&
      allData.floors[currentFloor].areas.length >= parseInt(props.match.params.area) &&
      parseInt(props.match.params.area) > 0
    ){

      // エリア番号の取得
      currentArea = parseInt(props.match.params.area) - 1;

      // prev,nextの取得
      let isActive7:number;
      if(currentArea >= 13){
        isActive7 = 1;
      }else{
        isActive7 = 0;
      }

      const orderIndex = areaOrder[currentFloor+isActive7].findIndex((v) => v.id===currentArea);

      // prev
      if(orderIndex === 0){
        prevArea = areaOrder[currentFloor+isActive7][areaOrder[currentFloor+isActive7].length-1].id;
      }else{
        prevArea = areaOrder[currentFloor+isActive7][orderIndex-1].id;
      }

      // next
      if(areaOrder[currentFloor+isActive7].length-1 === orderIndex){  // 最後の番号にマッチしたとき
        nextArea = areaOrder[currentFloor+isActive7][0].id;
      }else{
        nextArea = areaOrder[currentFloor+isActive7][orderIndex+1].id;
      }
    }
  }
  let currentAreaObj = allData.floors[currentFloor].areas[currentArea];
  const isActivityArea:boolean = currentArea >= 13;

  // ケタ追加用関数
  const zeroPadding = (num:number): string => {
    return ( '00' + num ).slice( -2 );
  }

  const handleChangeFloor = (floor:number, e: React.MouseEvent<HTMLAnchorElement, MouseEvent>)=>{
    e.preventDefault();
    setActiveFloor(floor);
  }

  const handleOpenModal = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,modalId:number)=>{
    e.preventDefault();

    // マルケト
    console.log(`[marketo_clickLink] url: ${e.currentTarget.href}`);
    (window as any).Munchkin.munchkinFunction('clickLink', {
      'href': e.currentTarget.href
    });

    setActiveModal(modalId);
  }

  const handleCloseModal = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>)=>{
    e.preventDefault();
    setActiveModal(-1);
  }

  const handleGotoSlide = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, slideId:number)=>{
    e.preventDefault();
    elSlider.slickGoTo(slideId);
  }

  const handleMoveTo = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>)=>{
    e.preventDefault();

    // マルケト
    console.log(`[marketo_clickLink] url: ${e.currentTarget.href}`);
    (window as any).Munchkin.munchkinFunction('clickLink', {
      'href': e.currentTarget.href
    });

    // 新しいウィンドウで遷移する
    window.open(e.currentTarget.href, 'win01', 'width=500,toolbar=yes,menubar=yes,scrollbars=yes');
  }

  // Effect
  useEffect(() => {

    // タイトルなど
    // document.title = `フロア${currentFloor} - エリア${currentArea}`;

    // activeFloorの設定
    if(currentFloor === 1){
      if(isActivityArea){
        setActiveFloor(5);  // 7 ACTIVITIES
      }else{
        setActiveFloor(4);  // 4F
      }
    }

    // クエリパラメータslideのチェック
    if(qs.slide !== null && !Array.isArray(qs.slide) && !isNaN(parseInt(qs.slide)) && parseInt(qs.slide) >= 0 ){

      // 指定されたslideがあるかどうかのチェック
      if( allData.floors[currentFloor].areas[currentArea].slides.length > parseInt(qs.slide) ){

        //スライドを移動
        setActiveSlide(parseInt(qs.slide));
        elSlider.slickGoTo(parseInt(qs.slide),true);

        // クエリパラメータmodalのチェック
        if(qs.modal !== null && !Array.isArray(qs.modal) && !isNaN(parseInt(qs.modal))){

          // 指定されたモーダルがあるかどうかのチェック
          if( allData.floors[currentFloor].areas[currentArea].slides[parseInt(qs.slide)].modals.length > parseInt(qs.modal) ){
            setActiveModal(parseInt(qs.modal));
          }
        }
      }
    }
  },[currentAreaObj.slides.length, isActivityArea, elSlider, currentFloor, currentArea, qs.slide, qs.modal]);

  // Effect2
  useEffect(() => {

    // ページ遷移時にメニューを閉じる
    return () => {
      dispatch(closeMenu());
    }
  });

  return (
    <div id="PageFloor" className={activeModal!==-1 ? 'st-scrollLock' : ''}>
      <Header />
      <Menu />
      { isActivityArea ? 
        <SubHeader active={2} />
        :
        <SubHeader active={1} />
      }

      <div className="wrapper">
        <div className="headArea">
          <div className="naviLeft">
            <p className="btnArea"><Link to={`/digital/fair2021/showroom/floor${currentFloor + 3}/area${zeroPadding(prevArea+1)}.html`}>BACK</Link></p>
          </div>
          <div className="titleArea">
            <div className="main"><h3 dangerouslySetInnerHTML={{__html: currentAreaObj.title}}></h3></div>
            <div className="sub" dangerouslySetInnerHTML={{__html: currentAreaObj.lead}}></div>
          </div>
          <div className="naviRight">
            <p className="btnArea"><Link to={`/digital/fair2021/showroom/floor${currentFloor + 3}/area${zeroPadding(nextArea+1)}.html`}>NEXT</Link></p>
          </div>
        </div>
        <div className="bodyArea">
          <div className="leftArea">
            <div className={currentAreaObj.slides.length === 1 ? 'slide no-slide' : 'slide'}>
              <Slider ref={slider => (elSlider = slider)} {...settings}>

                {/* スライダーループ ここから */}
                {currentAreaObj.slides.map((s,i)=>{
                  return(
                    <div key={i} className="imgWrap">
                      <div className="img"><img src={`${props.testPath}/asset/floor/floor${currentFloor}_area${currentArea}_slide${i}.png`} alt=""/></div>
                      <ul className="point">

                        {/* モーダルループ ここから */}
                        {s.modals.map((m,j) => {

                          // リンクの種類判定
                          if(m.title === '' ){  // ダイレクトリンク
                            return(
                              <li key={j} style={{
                                top:"calc( " + m.y + " / 580 * 100%)",
                                right:"calc( " + m.x + " / 960 * 100%)"
                              }} className="directLink"><a href={m.url} onClick={(e)=>handleMoveTo(e)} rel="noreferrer" target="_blank">製品サイトへ</a></li>
                            );
                          }else if(m.title === '動画'){ // 動画リンク
                            return(
                              <li key={j} style={{
                                top:"calc( " + m.y + " / 580 * 100%)",
                                left:"calc( " + m.x + " / 960 * 100%)"
                              }} className="movieLink"><a href={`/digital/fair2021/showroom/floor${currentFloor+3}/area${currentArea+1}.html?slide=${i}&modal=${j}`} onClick={(e)=>{handleOpenModal(e,j)}}>{`modal${j}`}</a></li>
                            );
                          }else{
                            return(
                              <li key={j} style={{
                                top:"calc( " + m.y + " / 580 * 100%)",
                                left:"calc( " + m.x + " / 960 * 100%)"
                              }} className="modalLink"><a href={`/digital/fair2021/showroom/floor${currentFloor+3}/area${currentArea+1}.html?slide=${i}&modal=${j}`} onClick={(e)=>{handleOpenModal(e,j)}}>{`modal${j}`}</a></li>
                            );
                          }
                        })}
                        {/* モーダルループ ここまで */}

                      </ul>
                    </div>
                  );
                })}
                {/* スライダーループ ここまで */}

              </Slider>

            </div>
          </div>
          <div className="rightArea">

            { isActivityArea ?
              <div className="activityThumb">
                <ul>
                  {/* スライダーループ ここから */}
                  {currentAreaObj.slides.map((s,i)=>{
                    if(activeSlide===i){
                      return(
                        <li key={i}><img src={`${props.testPath}/asset/floor/floor${currentFloor}_area${currentArea}_activity${i}.png`} alt=""/><span dangerouslySetInnerHTML={{__html: s.text}}></span></li>
                      );
                    }else{ return null }
                  })}
                  {/* スライダーループ ここまで */}
                </ul>
              </div>
              :
              <div className="floorNavi" data-active-floor={activeFloor}>
                {
                activeFloor===3 ?
                  <div className="floor3"><FloorMap3 active={currentFloor===0 ? currentArea : currentArea+100} /></div>
                :
                  <div className="floor4"><FloorMap4 active={currentFloor===0 ? currentArea : currentArea+100} /></div>
                }
                <ul>
              <li><a href="/" onClick={(e)=>{handleChangeFloor(3, e)}}>3F</a></li>
                  <li><a href="/" onClick={(e)=>{handleChangeFloor(4, e)}}>4F</a></li>
                  {/* <li><a href="/" onClick={(e)=>{handleChangeFloor(5, e)}}>7 ACTIVITIES</a></li> */}
                </ul>
              </div>
            }

            {isActivityArea ?
              currentAreaObj.slides.length > 1 &&   
              // アクティビティナビ
                <div className={'activityNavi'}>
                  <ul>
                    {/* スライダーループ ここから */}
                    {currentAreaObj.slides.map((s,i)=>{
                        return(
                          <li key={i} className={activeSlide===i ? `active` : ''}><a href="/" onClick={e => handleGotoSlide(e,i)}><img src={`${props.testPath}/asset/floor/floor${currentFloor}_area${currentArea}_activity${i}.png`} alt=""/></a></li>
                        );                    
                    })}
                    {/* スライダーループ ここまで */}
                    <li className="blank"></li>
                    <li className="blank"></li>
                    <li className="blank"></li>
                    <li className="blank"></li>
                  </ul>
                </div>
            :
              currentAreaObj.slides.length > 1 &&
              // スライドナビ
              <div className={'slideNavi'}>
                <ul>
                  {/* スライダーループ ここから */}
                  {currentAreaObj.slides.map((s,i)=>{
                    return(
                      <li key={i} className={activeSlide===i ? `active` : ''}><a href="/" onClick={e => handleGotoSlide(e,i)}><img src={`${props.testPath}/asset/floor/floor${currentFloor}_area${currentArea}_slide${i}.png`} alt=""/></a></li>
                    );
                  })}
                  {/* スライダーループ ここまで */}
                </ul>
              </div>
            }
          </div>
        </div>
      </div>
      {/* フロアページ<br />
      階数：{props.match.params.floor}<br />
      部屋番号：{props.match.params.area} */}

      {/* { activeModal!==-1 &&
        <div className='modalBg st-open'>
          <div className="modal">
            <div className="scroll">
                {(currentFloor===1 && currentArea===0 && activeSlide===0 && activeModal===1 ) ?
                  // ムービーモーダル
                  <div className="modalInner isMovie">
                    <div><div><iframe src="https://players.brightcove.net/4907834175001/NrSOSKjf6_default/index.html?videoId=6208953879001" allowFullScreen={true} allow="encrypted-media" title="movie"></iframe></div></div>
                  </div>
                :
                  // 通常モーダル
                  <div className="modalInner">
                    <div className="leftArea"><img src={`${props.testPath}/asset/floor/floor${currentFloor}_area${currentArea}_slide${activeSlide}_modal${activeModal}.png`} alt=""/></div>
                    <div className="rightArea">
                      <div className="productName">{currentAreaObj.slides[activeSlide].modals[activeModal].title}</div>
                      <div className="lead1" dangerouslySetInnerHTML={{__html: currentAreaObj.slides[activeSlide].modals[activeModal].lead1}}></div>
                      <div className="lead2" dangerouslySetInnerHTML={{__html: currentAreaObj.slides[activeSlide].modals[activeModal].lead2}}></div>
                      <div className="btnArea"><a href={currentAreaObj.slides[activeSlide].modals[activeModal].url} rel="noreferrer" target="_blank">製品サイトへ</a></div>
                    </div>
                  </div>
                }
              <div className="btnCloseArea"><a href="/" onClick={(e)=>{handleCloseModal(e)}}>CLOSE</a></div>
            </div>
          </div>
        </div>
      } */}
      { activeModal!==-1 &&
        <Modal
          testPath={props.testPath}
          currentFloor={currentFloor}
          currentArea={currentArea}
          activeSlide={activeSlide}
          activeModal={activeModal}
          currentAreaObj={currentAreaObj}
          handleCloseModal={handleCloseModal}
        />
      }
      <Footer />
    </div>
  );
}

export default PageFloor;
